// @ts-nocheck
import './BackgroundDecor.css';
import React from 'react';
import { cn as classNames } from '../../utils/bem';
var cn = classNames('BackgroundDecor');
export var backgroundDecorPropView = [
    'left-rombus-up',
    'left-rombus-down',
    'left-triangle-up-1',
    'left-triangle-down-1',
    'left-triangle-up-3',
    'left-triangle-down-3',
    'left-triangle-up-4',
    'left-triangle-down-4',
    'left-triangle-up-5',
    'left-triangle-down-5',
    'left-triangle-up-6',
    'left-triangle-down-6',
    'left-triangle-up-7',
    'left-triangle-down-7',
    'right-rombus-up',
    'right-rombus-down',
    'right-triangle-up-1',
    'right-triangle-down-1',
    'right-triangle-up-3',
    'right-triangle-down-3',
    'right-triangle-up-2',
    'right-triangle-down-2',
    'right-triangle-up-5',
    'right-triangle-down-5',
];
export var backgroundDecorPropViewDefault = backgroundDecorPropView[0];
export var BackgroundDecor = function (_a) {
    var view = _a.view, position = _a.position, offset = _a.offset, color = _a.color, fill = _a.fill;
    return React.createElement("div", { className: cn({ view: view, position: position, offset: offset, color: color, fill: fill }) });
};
